export default "__VITE_ASSET__k4PT6A1N__"